import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'

const Layout = () => {
  return (
    <>
    <Header/>
    <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
    <Sidebar />
 
 <Outlet/>
   
  </div>
    </>
  )
}

export default Layout